import { Button, Col, DatePicker, Form, Input, Select } from 'antd'
import {
  OPTIONS_PACKAGE_STATUS,
  OPTIONS_PACKAGE_TYPE,
  OPTIONS_PAYMENT_METHOD,
  OPTIONS_TYPE_REQUEST
} from '../../configData'
import { v4 as uuidv4 } from 'uuid'
import { removeVietnameseTones } from '../../config-func'
import { debounce } from 'lodash'
const { RangePicker } = DatePicker
const { Option } = Select

const SearchForm = ({ fetchData, handleSearch, setFilters, setIsDisabled }) => {
  const [form] = Form.useForm()

  const handleReset = debounce(() => {
    setFilters({ currentPage: 1, pageSize: 10, reset: uuidv4() })
    form.resetFields()
    // fetchData()
    setIsDisabled(true)
  }, 300)

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSearch}
      style={{ marginTop: 10 }}
      onValuesChange={(value, allValues) => {
        setFilters((prev) => ({ ...prev, ...allValues }))
      }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '16px',
          alignItems: 'center'
        }}
      >
        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Họ và tên/ Số điện thoại" name="name">
            <Input
              placeholder="Nhập thông tin"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'name',
                    value: e.target.value?.trim()
                  }
                ])
              }}
            />
          </Form.Item>
        </div>
        {/* <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Nhu cầu" name="type">
            <Select style={{ width: '100%' }} placeholder="Chọn loại giao dịch" 
            allowClear
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) => {
              const inputValue = removeVietnameseTones(input).toLowerCase();
              const optionValue = removeVietnameseTones(option?.children || '').toLowerCase();
              return optionValue.includes(inputValue);
            }}
            >
              <Option value={''}>Tất cả</Option>
              {OPTIONS_PACKAGE_TYPE?.map((item, idx) => (
                <Option key={idx} value={item.value}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div> */}
        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Trạng thái" name="status">
            <Select style={{ width: '100%' }} placeholder="Chọn trạng thái" 
            allowClear
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) => {
              const inputValue = removeVietnameseTones(input).toLowerCase();
              const optionValue = removeVietnameseTones(option?.children || '').toLowerCase();
              return optionValue.includes(inputValue);
            }}
            >
              <Option value={''}>Tất cả</Option>
              {OPTIONS_PACKAGE_STATUS?.map((item, idx) => (
                <Option key={idx} value={item.value}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>

        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Phương thức thanh toán" name="payment_method">
            <Select style={{ width: '100%' }} placeholder="Chọn phương thức thanh toán" 
            allowClear
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) => {
              const inputValue = removeVietnameseTones(input).toLowerCase();
              const optionValue = removeVietnameseTones(option?.children || '').toLowerCase();
              return optionValue.includes(inputValue);
            }}
            >
              <Option value={''}>Tất cả</Option>
              {OPTIONS_PAYMENT_METHOD?.map((item, idx) => (
                <Option key={idx} value={item.value}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>

        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Thời gian" name="date">
            <RangePicker
              // value={dates}
              // onChange={(dates) => setDates(dates)}
              format="DD/MM/YYYY"
              style={{ width: '100%' }}
            />
          </Form.Item>
        </div>
        <div
          style={{
            display: 'flex',
            gap: '8px',
            justifyContent: 'flex-end',
            flex: '1 1 200px',
            minWidth: '200px'
          }}
        >
          <Button onClick={handleReset}>Đặt lại</Button>
          <Button type="primary" htmlType="submit" style={{ margin: '0 8px' }}>
            Tìm kiếm
          </Button>
        </div>
      </div>
    </Form>
  )
}

export default SearchForm
